import { render, staticRenderFns } from "./new_claims.vue?vue&type=template&id=19560edc&scoped=true"
import script from "./new_claims.vue?vue&type=script&lang=js"
export * from "./new_claims.vue?vue&type=script&lang=js"
import style0 from "./new_claims.vue?vue&type=style&index=0&id=19560edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19560edc",
  null
  
)

export default component.exports